import type {
  MarketingAchievementMemberRowVO,
  MarketingAchievementMemberTierActionVO,
} from "@/api/memberBenefit/type";

/** 是否已点亮至少一档 */
export const isAchievementUnlocked = (row: MarketingAchievementMemberRowVO): boolean =>
  row.currentTierIndex != null;

/** 下一档门槛（已满级为 null） */
export const getNextTierThreshold = (
  row: MarketingAchievementMemberRowVO,
): MarketingAchievementMemberTierActionVO | null => {
  if (row.nextTierIndex == null) return null;
  const tiers = row.tierActions ?? [];
  return tiers.find((t) => t.tierIndex === row.nextTierIndex) ?? null;
};

/** 当前进度文案，优先接口展示字段 */
export const formatAchievementCurrentText = (row: MarketingAchievementMemberRowVO): string => {
  const text = row.currentValueText?.trim();
  if (text) return text;
  if (row.currentValue == null) return "-";
  return `${row.currentValue}${row.unit ?? ""}`;
};

/**
 * 右侧进度：`18次 / 30次`；已满级为 `18次 / 已满级`
 */
export const formatAchievementProgressPair = (
  row: MarketingAchievementMemberRowVO,
): { current: string; target: string } => {
  const current = formatAchievementCurrentText(row);
  const next = getNextTierThreshold(row);
  if (!next || next.threshold == null) {
    return { current, target: "已满级" };
  }
  return { current, target: `${next.threshold}${row.unit ?? ""}` };
};

/**
 * 进度条百分比 0–100。
 * 相对下一档门槛累计；已满级为 100。
 */
export const achievementProgressPercent = (row: MarketingAchievementMemberRowVO): number => {
  if (row.nextTierIndex == null) return 100;
  const next = getNextTierThreshold(row);
  if (!next || next.threshold == null || next.threshold <= 0) return 0;
  const current = Number(row.currentValue ?? 0);
  return Math.min(100, Math.max(0, (current / next.threshold) * 100));
};
